
export default function Footer({ onDemoClick }) {
  const cols = [
    {
      title: "Produto",
      links: [
        { label: "Funcionalidades", href: "#funcionalidades" },
        { label: "Como Funciona", href: "#como-funciona" },
        { label: "Segurança", href: "#seguranca" },
        { label: "FAQ", href: "#faq" },
      ],
    },
    {
      title: "Empresa",
      links: [
        { label: "Experimente 7 dias grátis", href: "#demo", isDemo: true },
        { label: "Contacto", href: "mailto:ola@automia.pt" },
        { label: "Privacidade", href: "/privacidade" },
        { label: "Termos", href: "/termos" },
      ],
    },
  ];

  return (
    <footer data-testid="site-footer" className="relative pt-20 pb-10 border-t border-white/[0.06] bg-[#020611]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <img src="/automialogo.png" alt="Automia" className="h-14 w-auto" />
            </div>
            <p className="mt-5 text-slate-400 max-w-md leading-relaxed">
              Atendimento e marcações automáticos no WhatsApp, em Português de Portugal.
              Sem alucinações. Sempre disponível.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-xs text-slate-500">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              Sistema operacional · resposta média 1.2s
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-4">
                  {c.title}
                </div>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      {l.isDemo ? (
                        <button
                          onClick={onDemoClick}
                          className="text-sm text-blue-400 hover:text-blue-300 transition-colors"
                        >
                          {l.label}
                        </button>
                      ) : (
                        <a
                          href={l.href}
                          className="text-sm text-slate-300 hover:text-white transition-colors"
                        >
                          {l.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Automia. Feito em Portugal.</div>
          <div className="flex items-center gap-5">
            <a href="/privacidade" className="hover:text-slate-300">Privacidade</a>
            <a href="/termos" className="hover:text-slate-300">Termos</a>
            <a href="/rgpd" className="hover:text-slate-300">RGPD</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
